export var ASC = 'ASC';
export var DESC = 'DESC';

export var SMALL = 'small';
export var MEDIUM = 'medium';
export var LARGE = 'large';
export var XLARGE = 'xlarge';

export var LOADING_CONTENTS_OPACITY = 0.22;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dynamic-table/dist/esm/internal/constants.js
// module id = 91
// module chunks = 0